/* tslint:disable */
/* eslint-disable */
/**
 * Modulos Platform API v2
 * API for the Modulos Platform.
 *
 * The version of the OpenAPI document: 2.5.7
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateEvidenceRequest } from '../model';
// @ts-ignore
import type { EvidenceExpandedPaginated } from '../model';
// @ts-ignore
import type { EvidenceExpandedResponse } from '../model';
// @ts-ignore
import type { EvidencePaginated } from '../model';
// @ts-ignore
import type { EvidenceResponse } from '../model';
// @ts-ignore
import type { EvidenceSorting } from '../model';
// @ts-ignore
import type { EvidenceSuggestions } from '../model';
// @ts-ignore
import type { EvidenceUrlResponse } from '../model';
// @ts-ignore
import type { HTTPValidationError } from '../model';
// @ts-ignore
import type { UpdateEvidenceRequest } from '../model';
/**
 * EvidenceApi - axios parameter creator
 */
export const EvidenceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create Evidence
         * @param {CreateEvidenceRequest} createEvidenceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEvidence: async (createEvidenceRequest: CreateEvidenceRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createEvidenceRequest' is not null or undefined
            assertParamExists('createEvidence', 'createEvidenceRequest', createEvidenceRequest)
            const localVarPath = `/evidence/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createEvidenceRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Evidence Suggestions
         * @param {string} evidenceId 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEvidenceSuggestions: async (evidenceId: string, projectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'evidenceId' is not null or undefined
            assertParamExists('createEvidenceSuggestions', 'evidenceId', evidenceId)
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('createEvidenceSuggestions', 'projectId', projectId)
            const localVarPath = `/evidence/{evidence_id}/suggestions`
                .replace('{evidence_id}', encodeURIComponent(String(evidenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (projectId !== undefined) {
                localVarQueryParameter['project_id'] = projectId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Evidence
         * @param {string} evidenceId 
         * @param {string | null} [projectId] The AI System the evidence must belong to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEvidence: async (evidenceId: string, projectId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'evidenceId' is not null or undefined
            assertParamExists('deleteEvidence', 'evidenceId', evidenceId)
            const localVarPath = `/evidence/{evidence_id}`
                .replace('{evidence_id}', encodeURIComponent(String(evidenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (projectId !== undefined) {
                localVarQueryParameter['project_id'] = projectId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Download Evidence
         * @param {string} evidenceId 
         * @param {string | null} [projectId] The AI System the evidence must belong to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadEvidence: async (evidenceId: string, projectId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'evidenceId' is not null or undefined
            assertParamExists('downloadEvidence', 'evidenceId', evidenceId)
            const localVarPath = `/evidence/{evidence_id}/download`
                .replace('{evidence_id}', encodeURIComponent(String(evidenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (projectId !== undefined) {
                localVarQueryParameter['project_id'] = projectId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Evidence
         * @param {string} evidenceId 
         * @param {string | null} [projectId] The AI System the evidence must belong to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvidence: async (evidenceId: string, projectId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'evidenceId' is not null or undefined
            assertParamExists('getEvidence', 'evidenceId', evidenceId)
            const localVarPath = `/evidence/{evidence_id}`
                .replace('{evidence_id}', encodeURIComponent(String(evidenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (projectId !== undefined) {
                localVarQueryParameter['project_id'] = projectId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return the evidence with the controls, lock state and users a detail view renders.
         * @summary Get Evidence Expanded
         * @param {string} evidenceId 
         * @param {string | null} [projectId] The AI System the evidence must belong to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvidenceExpanded: async (evidenceId: string, projectId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'evidenceId' is not null or undefined
            assertParamExists('getEvidenceExpanded', 'evidenceId', evidenceId)
            const localVarPath = `/evidence/{evidence_id}/expanded`
                .replace('{evidence_id}', encodeURIComponent(String(evidenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (projectId !== undefined) {
                localVarQueryParameter['project_id'] = projectId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Evidence File Types
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvidenceFileTypes: async (projectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getEvidenceFileTypes', 'projectId', projectId)
            const localVarPath = `/evidence/file-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (projectId !== undefined) {
                localVarQueryParameter['project_id'] = projectId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Evidence Url
         * @param {string} evidenceId 
         * @param {string | null} [projectId] The AI System the evidence must belong to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvidenceUrl: async (evidenceId: string, projectId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'evidenceId' is not null or undefined
            assertParamExists('getEvidenceUrl', 'evidenceId', evidenceId)
            const localVarPath = `/evidence/{evidence_id}/url`
                .replace('{evidence_id}', encodeURIComponent(String(evidenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (projectId !== undefined) {
                localVarQueryParameter['project_id'] = projectId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Link Evidence To Component
         * @param {string} componentId 
         * @param {string} evidenceId 
         * @param {string | null} [projectId] The AI System the evidence must belong to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkEvidenceToComponent: async (componentId: string, evidenceId: string, projectId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'componentId' is not null or undefined
            assertParamExists('linkEvidenceToComponent', 'componentId', componentId)
            // verify required parameter 'evidenceId' is not null or undefined
            assertParamExists('linkEvidenceToComponent', 'evidenceId', evidenceId)
            const localVarPath = `/evidence/{evidence_id}/components/{component_id}`
                .replace('{component_id}', encodeURIComponent(String(componentId)))
                .replace('{evidence_id}', encodeURIComponent(String(evidenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (projectId !== undefined) {
                localVarQueryParameter['project_id'] = projectId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Link Evidence To Control
         * @param {string} controlId 
         * @param {string} evidenceId 
         * @param {string | null} [projectId] The AI System the evidence must belong to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkEvidenceToControl: async (controlId: string, evidenceId: string, projectId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'controlId' is not null or undefined
            assertParamExists('linkEvidenceToControl', 'controlId', controlId)
            // verify required parameter 'evidenceId' is not null or undefined
            assertParamExists('linkEvidenceToControl', 'evidenceId', evidenceId)
            const localVarPath = `/evidence/{evidence_id}/controls/{control_id}`
                .replace('{control_id}', encodeURIComponent(String(controlId)))
                .replace('{evidence_id}', encodeURIComponent(String(evidenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (projectId !== undefined) {
                localVarQueryParameter['project_id'] = projectId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Query Evidences
         * @param {string} projectId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {EvidenceSorting | null} [sortBy] 
         * @param {boolean | null} [descending] 
         * @param {string | null} [name] 
         * @param {string | null} [uniqueCode] 
         * @param {string | null} [fileType] 
         * @param {Array<string>} [associatedControlIds] Keep evidences linked to any of these controls
         * @param {string | null} [startDate] 
         * @param {string | null} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryEvidences: async (projectId: string, page?: number, size?: number, sortBy?: EvidenceSorting | null, descending?: boolean | null, name?: string | null, uniqueCode?: string | null, fileType?: string | null, associatedControlIds?: Array<string>, startDate?: string | null, endDate?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('queryEvidences', 'projectId', projectId)
            const localVarPath = `/evidence/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (descending !== undefined) {
                localVarQueryParameter['descending'] = descending;
            }

            if (projectId !== undefined) {
                localVarQueryParameter['project_id'] = projectId;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (uniqueCode !== undefined) {
                localVarQueryParameter['unique_code'] = uniqueCode;
            }

            if (fileType !== undefined) {
                localVarQueryParameter['file_type'] = fileType;
            }

            if (associatedControlIds) {
                localVarQueryParameter['associated_control_ids'] = associatedControlIds;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List evidences with the controls, lock state and users a list view renders.
         * @summary Query Evidences Expanded
         * @param {string} projectId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {EvidenceSorting | null} [sortBy] 
         * @param {boolean | null} [descending] 
         * @param {string | null} [name] 
         * @param {string | null} [uniqueCode] 
         * @param {string | null} [fileType] 
         * @param {Array<string>} [associatedControlIds] Keep evidences linked to any of these controls
         * @param {string | null} [startDate] 
         * @param {string | null} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryEvidencesExpanded: async (projectId: string, page?: number, size?: number, sortBy?: EvidenceSorting | null, descending?: boolean | null, name?: string | null, uniqueCode?: string | null, fileType?: string | null, associatedControlIds?: Array<string>, startDate?: string | null, endDate?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('queryEvidencesExpanded', 'projectId', projectId)
            const localVarPath = `/evidence/expanded`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (descending !== undefined) {
                localVarQueryParameter['descending'] = descending;
            }

            if (projectId !== undefined) {
                localVarQueryParameter['project_id'] = projectId;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (uniqueCode !== undefined) {
                localVarQueryParameter['unique_code'] = uniqueCode;
            }

            if (fileType !== undefined) {
                localVarQueryParameter['file_type'] = fileType;
            }

            if (associatedControlIds) {
                localVarQueryParameter['associated_control_ids'] = associatedControlIds;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Unlink Evidence From Component
         * @param {string} componentId 
         * @param {string} evidenceId 
         * @param {string | null} [projectId] The AI System the evidence must belong to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlinkEvidenceFromComponent: async (componentId: string, evidenceId: string, projectId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'componentId' is not null or undefined
            assertParamExists('unlinkEvidenceFromComponent', 'componentId', componentId)
            // verify required parameter 'evidenceId' is not null or undefined
            assertParamExists('unlinkEvidenceFromComponent', 'evidenceId', evidenceId)
            const localVarPath = `/evidence/{evidence_id}/components/{component_id}`
                .replace('{component_id}', encodeURIComponent(String(componentId)))
                .replace('{evidence_id}', encodeURIComponent(String(evidenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (projectId !== undefined) {
                localVarQueryParameter['project_id'] = projectId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Unlink Evidence From Control
         * @param {string} controlId 
         * @param {string} evidenceId 
         * @param {string | null} [projectId] The AI System the evidence must belong to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlinkEvidenceFromControl: async (controlId: string, evidenceId: string, projectId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'controlId' is not null or undefined
            assertParamExists('unlinkEvidenceFromControl', 'controlId', controlId)
            // verify required parameter 'evidenceId' is not null or undefined
            assertParamExists('unlinkEvidenceFromControl', 'evidenceId', evidenceId)
            const localVarPath = `/evidence/{evidence_id}/controls/{control_id}`
                .replace('{control_id}', encodeURIComponent(String(controlId)))
                .replace('{evidence_id}', encodeURIComponent(String(evidenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (projectId !== undefined) {
                localVarQueryParameter['project_id'] = projectId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Evidence
         * @param {string} evidenceId 
         * @param {UpdateEvidenceRequest} updateEvidenceRequest 
         * @param {string | null} [projectId] The AI System the evidence must belong to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEvidence: async (evidenceId: string, updateEvidenceRequest: UpdateEvidenceRequest, projectId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'evidenceId' is not null or undefined
            assertParamExists('updateEvidence', 'evidenceId', evidenceId)
            // verify required parameter 'updateEvidenceRequest' is not null or undefined
            assertParamExists('updateEvidence', 'updateEvidenceRequest', updateEvidenceRequest)
            const localVarPath = `/evidence/{evidence_id}`
                .replace('{evidence_id}', encodeURIComponent(String(evidenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (projectId !== undefined) {
                localVarQueryParameter['project_id'] = projectId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEvidenceRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EvidenceApi - functional programming interface
 */
export const EvidenceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EvidenceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create Evidence
         * @param {CreateEvidenceRequest} createEvidenceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEvidence(createEvidenceRequest: CreateEvidenceRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EvidenceResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEvidence(createEvidenceRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EvidenceApi.createEvidence']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create Evidence Suggestions
         * @param {string} evidenceId 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEvidenceSuggestions(evidenceId: string, projectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EvidenceSuggestions>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEvidenceSuggestions(evidenceId, projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EvidenceApi.createEvidenceSuggestions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Evidence
         * @param {string} evidenceId 
         * @param {string | null} [projectId] The AI System the evidence must belong to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEvidence(evidenceId: string, projectId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEvidence(evidenceId, projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EvidenceApi.deleteEvidence']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Download Evidence
         * @param {string} evidenceId 
         * @param {string | null} [projectId] The AI System the evidence must belong to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadEvidence(evidenceId: string, projectId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadEvidence(evidenceId, projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EvidenceApi.downloadEvidence']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Evidence
         * @param {string} evidenceId 
         * @param {string | null} [projectId] The AI System the evidence must belong to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEvidence(evidenceId: string, projectId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EvidenceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEvidence(evidenceId, projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EvidenceApi.getEvidence']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return the evidence with the controls, lock state and users a detail view renders.
         * @summary Get Evidence Expanded
         * @param {string} evidenceId 
         * @param {string | null} [projectId] The AI System the evidence must belong to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEvidenceExpanded(evidenceId: string, projectId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EvidenceExpandedResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEvidenceExpanded(evidenceId, projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EvidenceApi.getEvidenceExpanded']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Evidence File Types
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEvidenceFileTypes(projectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string | null>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEvidenceFileTypes(projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EvidenceApi.getEvidenceFileTypes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Evidence Url
         * @param {string} evidenceId 
         * @param {string | null} [projectId] The AI System the evidence must belong to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEvidenceUrl(evidenceId: string, projectId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EvidenceUrlResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEvidenceUrl(evidenceId, projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EvidenceApi.getEvidenceUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Link Evidence To Component
         * @param {string} componentId 
         * @param {string} evidenceId 
         * @param {string | null} [projectId] The AI System the evidence must belong to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async linkEvidenceToComponent(componentId: string, evidenceId: string, projectId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EvidenceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.linkEvidenceToComponent(componentId, evidenceId, projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EvidenceApi.linkEvidenceToComponent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Link Evidence To Control
         * @param {string} controlId 
         * @param {string} evidenceId 
         * @param {string | null} [projectId] The AI System the evidence must belong to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async linkEvidenceToControl(controlId: string, evidenceId: string, projectId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EvidenceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.linkEvidenceToControl(controlId, evidenceId, projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EvidenceApi.linkEvidenceToControl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Query Evidences
         * @param {string} projectId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {EvidenceSorting | null} [sortBy] 
         * @param {boolean | null} [descending] 
         * @param {string | null} [name] 
         * @param {string | null} [uniqueCode] 
         * @param {string | null} [fileType] 
         * @param {Array<string>} [associatedControlIds] Keep evidences linked to any of these controls
         * @param {string | null} [startDate] 
         * @param {string | null} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async queryEvidences(projectId: string, page?: number, size?: number, sortBy?: EvidenceSorting | null, descending?: boolean | null, name?: string | null, uniqueCode?: string | null, fileType?: string | null, associatedControlIds?: Array<string>, startDate?: string | null, endDate?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EvidencePaginated>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.queryEvidences(projectId, page, size, sortBy, descending, name, uniqueCode, fileType, associatedControlIds, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EvidenceApi.queryEvidences']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List evidences with the controls, lock state and users a list view renders.
         * @summary Query Evidences Expanded
         * @param {string} projectId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {EvidenceSorting | null} [sortBy] 
         * @param {boolean | null} [descending] 
         * @param {string | null} [name] 
         * @param {string | null} [uniqueCode] 
         * @param {string | null} [fileType] 
         * @param {Array<string>} [associatedControlIds] Keep evidences linked to any of these controls
         * @param {string | null} [startDate] 
         * @param {string | null} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async queryEvidencesExpanded(projectId: string, page?: number, size?: number, sortBy?: EvidenceSorting | null, descending?: boolean | null, name?: string | null, uniqueCode?: string | null, fileType?: string | null, associatedControlIds?: Array<string>, startDate?: string | null, endDate?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EvidenceExpandedPaginated>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.queryEvidencesExpanded(projectId, page, size, sortBy, descending, name, uniqueCode, fileType, associatedControlIds, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EvidenceApi.queryEvidencesExpanded']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Unlink Evidence From Component
         * @param {string} componentId 
         * @param {string} evidenceId 
         * @param {string | null} [projectId] The AI System the evidence must belong to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unlinkEvidenceFromComponent(componentId: string, evidenceId: string, projectId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unlinkEvidenceFromComponent(componentId, evidenceId, projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EvidenceApi.unlinkEvidenceFromComponent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Unlink Evidence From Control
         * @param {string} controlId 
         * @param {string} evidenceId 
         * @param {string | null} [projectId] The AI System the evidence must belong to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unlinkEvidenceFromControl(controlId: string, evidenceId: string, projectId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unlinkEvidenceFromControl(controlId, evidenceId, projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EvidenceApi.unlinkEvidenceFromControl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Evidence
         * @param {string} evidenceId 
         * @param {UpdateEvidenceRequest} updateEvidenceRequest 
         * @param {string | null} [projectId] The AI System the evidence must belong to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEvidence(evidenceId: string, updateEvidenceRequest: UpdateEvidenceRequest, projectId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EvidenceExpandedResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEvidence(evidenceId, updateEvidenceRequest, projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EvidenceApi.updateEvidence']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EvidenceApi - factory interface
 */
export const EvidenceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EvidenceApiFp(configuration)
    return {
        /**
         * 
         * @summary Create Evidence
         * @param {EvidenceApiCreateEvidenceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEvidence(requestParameters: EvidenceApiCreateEvidenceRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<EvidenceResponse>> {
            return localVarFp.createEvidence(requestParameters.createEvidenceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Evidence Suggestions
         * @param {EvidenceApiCreateEvidenceSuggestionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEvidenceSuggestions(requestParameters: EvidenceApiCreateEvidenceSuggestionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<EvidenceSuggestions> {
            return localVarFp.createEvidenceSuggestions(requestParameters.evidenceId, requestParameters.projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Evidence
         * @param {EvidenceApiDeleteEvidenceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEvidence(requestParameters: EvidenceApiDeleteEvidenceRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteEvidence(requestParameters.evidenceId, requestParameters.projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Download Evidence
         * @param {EvidenceApiDownloadEvidenceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadEvidence(requestParameters: EvidenceApiDownloadEvidenceRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.downloadEvidence(requestParameters.evidenceId, requestParameters.projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Evidence
         * @param {EvidenceApiGetEvidenceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvidence(requestParameters: EvidenceApiGetEvidenceRequest, options?: RawAxiosRequestConfig): AxiosPromise<EvidenceResponse> {
            return localVarFp.getEvidence(requestParameters.evidenceId, requestParameters.projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * Return the evidence with the controls, lock state and users a detail view renders.
         * @summary Get Evidence Expanded
         * @param {EvidenceApiGetEvidenceExpandedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvidenceExpanded(requestParameters: EvidenceApiGetEvidenceExpandedRequest, options?: RawAxiosRequestConfig): AxiosPromise<EvidenceExpandedResponse> {
            return localVarFp.getEvidenceExpanded(requestParameters.evidenceId, requestParameters.projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Evidence File Types
         * @param {EvidenceApiGetEvidenceFileTypesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvidenceFileTypes(requestParameters: EvidenceApiGetEvidenceFileTypesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<string | null>> {
            return localVarFp.getEvidenceFileTypes(requestParameters.projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Evidence Url
         * @param {EvidenceApiGetEvidenceUrlRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvidenceUrl(requestParameters: EvidenceApiGetEvidenceUrlRequest, options?: RawAxiosRequestConfig): AxiosPromise<EvidenceUrlResponse> {
            return localVarFp.getEvidenceUrl(requestParameters.evidenceId, requestParameters.projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Link Evidence To Component
         * @param {EvidenceApiLinkEvidenceToComponentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkEvidenceToComponent(requestParameters: EvidenceApiLinkEvidenceToComponentRequest, options?: RawAxiosRequestConfig): AxiosPromise<EvidenceResponse> {
            return localVarFp.linkEvidenceToComponent(requestParameters.componentId, requestParameters.evidenceId, requestParameters.projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Link Evidence To Control
         * @param {EvidenceApiLinkEvidenceToControlRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkEvidenceToControl(requestParameters: EvidenceApiLinkEvidenceToControlRequest, options?: RawAxiosRequestConfig): AxiosPromise<EvidenceResponse> {
            return localVarFp.linkEvidenceToControl(requestParameters.controlId, requestParameters.evidenceId, requestParameters.projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Query Evidences
         * @param {EvidenceApiQueryEvidencesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryEvidences(requestParameters: EvidenceApiQueryEvidencesRequest, options?: RawAxiosRequestConfig): AxiosPromise<EvidencePaginated> {
            return localVarFp.queryEvidences(requestParameters.projectId, requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.descending, requestParameters.name, requestParameters.uniqueCode, requestParameters.fileType, requestParameters.associatedControlIds, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * List evidences with the controls, lock state and users a list view renders.
         * @summary Query Evidences Expanded
         * @param {EvidenceApiQueryEvidencesExpandedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryEvidencesExpanded(requestParameters: EvidenceApiQueryEvidencesExpandedRequest, options?: RawAxiosRequestConfig): AxiosPromise<EvidenceExpandedPaginated> {
            return localVarFp.queryEvidencesExpanded(requestParameters.projectId, requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.descending, requestParameters.name, requestParameters.uniqueCode, requestParameters.fileType, requestParameters.associatedControlIds, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Unlink Evidence From Component
         * @param {EvidenceApiUnlinkEvidenceFromComponentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlinkEvidenceFromComponent(requestParameters: EvidenceApiUnlinkEvidenceFromComponentRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.unlinkEvidenceFromComponent(requestParameters.componentId, requestParameters.evidenceId, requestParameters.projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Unlink Evidence From Control
         * @param {EvidenceApiUnlinkEvidenceFromControlRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlinkEvidenceFromControl(requestParameters: EvidenceApiUnlinkEvidenceFromControlRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.unlinkEvidenceFromControl(requestParameters.controlId, requestParameters.evidenceId, requestParameters.projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Evidence
         * @param {EvidenceApiUpdateEvidenceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEvidence(requestParameters: EvidenceApiUpdateEvidenceRequest, options?: RawAxiosRequestConfig): AxiosPromise<EvidenceExpandedResponse> {
            return localVarFp.updateEvidence(requestParameters.evidenceId, requestParameters.updateEvidenceRequest, requestParameters.projectId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createEvidence operation in EvidenceApi.
 */
export interface EvidenceApiCreateEvidenceRequest {
    readonly createEvidenceRequest: CreateEvidenceRequest
}

/**
 * Request parameters for createEvidenceSuggestions operation in EvidenceApi.
 */
export interface EvidenceApiCreateEvidenceSuggestionsRequest {
    readonly evidenceId: string

    readonly projectId: string
}

/**
 * Request parameters for deleteEvidence operation in EvidenceApi.
 */
export interface EvidenceApiDeleteEvidenceRequest {
    readonly evidenceId: string

    /**
     * The AI System the evidence must belong to
     */
    readonly projectId?: string | null
}

/**
 * Request parameters for downloadEvidence operation in EvidenceApi.
 */
export interface EvidenceApiDownloadEvidenceRequest {
    readonly evidenceId: string

    /**
     * The AI System the evidence must belong to
     */
    readonly projectId?: string | null
}

/**
 * Request parameters for getEvidence operation in EvidenceApi.
 */
export interface EvidenceApiGetEvidenceRequest {
    readonly evidenceId: string

    /**
     * The AI System the evidence must belong to
     */
    readonly projectId?: string | null
}

/**
 * Request parameters for getEvidenceExpanded operation in EvidenceApi.
 */
export interface EvidenceApiGetEvidenceExpandedRequest {
    readonly evidenceId: string

    /**
     * The AI System the evidence must belong to
     */
    readonly projectId?: string | null
}

/**
 * Request parameters for getEvidenceFileTypes operation in EvidenceApi.
 */
export interface EvidenceApiGetEvidenceFileTypesRequest {
    readonly projectId: string
}

/**
 * Request parameters for getEvidenceUrl operation in EvidenceApi.
 */
export interface EvidenceApiGetEvidenceUrlRequest {
    readonly evidenceId: string

    /**
     * The AI System the evidence must belong to
     */
    readonly projectId?: string | null
}

/**
 * Request parameters for linkEvidenceToComponent operation in EvidenceApi.
 */
export interface EvidenceApiLinkEvidenceToComponentRequest {
    readonly componentId: string

    readonly evidenceId: string

    /**
     * The AI System the evidence must belong to
     */
    readonly projectId?: string | null
}

/**
 * Request parameters for linkEvidenceToControl operation in EvidenceApi.
 */
export interface EvidenceApiLinkEvidenceToControlRequest {
    readonly controlId: string

    readonly evidenceId: string

    /**
     * The AI System the evidence must belong to
     */
    readonly projectId?: string | null
}

/**
 * Request parameters for queryEvidences operation in EvidenceApi.
 */
export interface EvidenceApiQueryEvidencesRequest {
    readonly projectId: string

    readonly page?: number

    readonly size?: number

    readonly sortBy?: EvidenceSorting | null

    readonly descending?: boolean | null

    readonly name?: string | null

    readonly uniqueCode?: string | null

    readonly fileType?: string | null

    /**
     * Keep evidences linked to any of these controls
     */
    readonly associatedControlIds?: Array<string>

    readonly startDate?: string | null

    readonly endDate?: string | null
}

/**
 * Request parameters for queryEvidencesExpanded operation in EvidenceApi.
 */
export interface EvidenceApiQueryEvidencesExpandedRequest {
    readonly projectId: string

    readonly page?: number

    readonly size?: number

    readonly sortBy?: EvidenceSorting | null

    readonly descending?: boolean | null

    readonly name?: string | null

    readonly uniqueCode?: string | null

    readonly fileType?: string | null

    /**
     * Keep evidences linked to any of these controls
     */
    readonly associatedControlIds?: Array<string>

    readonly startDate?: string | null

    readonly endDate?: string | null
}

/**
 * Request parameters for unlinkEvidenceFromComponent operation in EvidenceApi.
 */
export interface EvidenceApiUnlinkEvidenceFromComponentRequest {
    readonly componentId: string

    readonly evidenceId: string

    /**
     * The AI System the evidence must belong to
     */
    readonly projectId?: string | null
}

/**
 * Request parameters for unlinkEvidenceFromControl operation in EvidenceApi.
 */
export interface EvidenceApiUnlinkEvidenceFromControlRequest {
    readonly controlId: string

    readonly evidenceId: string

    /**
     * The AI System the evidence must belong to
     */
    readonly projectId?: string | null
}

/**
 * Request parameters for updateEvidence operation in EvidenceApi.
 */
export interface EvidenceApiUpdateEvidenceRequest {
    readonly evidenceId: string

    readonly updateEvidenceRequest: UpdateEvidenceRequest

    /**
     * The AI System the evidence must belong to
     */
    readonly projectId?: string | null
}

/**
 * EvidenceApi - object-oriented interface
 */
export class EvidenceApi extends BaseAPI {
    /**
     * 
     * @summary Create Evidence
     * @param {EvidenceApiCreateEvidenceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createEvidence(requestParameters: EvidenceApiCreateEvidenceRequest, options?: RawAxiosRequestConfig) {
        return EvidenceApiFp(this.configuration).createEvidence(requestParameters.createEvidenceRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Evidence Suggestions
     * @param {EvidenceApiCreateEvidenceSuggestionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createEvidenceSuggestions(requestParameters: EvidenceApiCreateEvidenceSuggestionsRequest, options?: RawAxiosRequestConfig) {
        return EvidenceApiFp(this.configuration).createEvidenceSuggestions(requestParameters.evidenceId, requestParameters.projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Evidence
     * @param {EvidenceApiDeleteEvidenceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteEvidence(requestParameters: EvidenceApiDeleteEvidenceRequest, options?: RawAxiosRequestConfig) {
        return EvidenceApiFp(this.configuration).deleteEvidence(requestParameters.evidenceId, requestParameters.projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Download Evidence
     * @param {EvidenceApiDownloadEvidenceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public downloadEvidence(requestParameters: EvidenceApiDownloadEvidenceRequest, options?: RawAxiosRequestConfig) {
        return EvidenceApiFp(this.configuration).downloadEvidence(requestParameters.evidenceId, requestParameters.projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Evidence
     * @param {EvidenceApiGetEvidenceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getEvidence(requestParameters: EvidenceApiGetEvidenceRequest, options?: RawAxiosRequestConfig) {
        return EvidenceApiFp(this.configuration).getEvidence(requestParameters.evidenceId, requestParameters.projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return the evidence with the controls, lock state and users a detail view renders.
     * @summary Get Evidence Expanded
     * @param {EvidenceApiGetEvidenceExpandedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getEvidenceExpanded(requestParameters: EvidenceApiGetEvidenceExpandedRequest, options?: RawAxiosRequestConfig) {
        return EvidenceApiFp(this.configuration).getEvidenceExpanded(requestParameters.evidenceId, requestParameters.projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Evidence File Types
     * @param {EvidenceApiGetEvidenceFileTypesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getEvidenceFileTypes(requestParameters: EvidenceApiGetEvidenceFileTypesRequest, options?: RawAxiosRequestConfig) {
        return EvidenceApiFp(this.configuration).getEvidenceFileTypes(requestParameters.projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Evidence Url
     * @param {EvidenceApiGetEvidenceUrlRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getEvidenceUrl(requestParameters: EvidenceApiGetEvidenceUrlRequest, options?: RawAxiosRequestConfig) {
        return EvidenceApiFp(this.configuration).getEvidenceUrl(requestParameters.evidenceId, requestParameters.projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Link Evidence To Component
     * @param {EvidenceApiLinkEvidenceToComponentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public linkEvidenceToComponent(requestParameters: EvidenceApiLinkEvidenceToComponentRequest, options?: RawAxiosRequestConfig) {
        return EvidenceApiFp(this.configuration).linkEvidenceToComponent(requestParameters.componentId, requestParameters.evidenceId, requestParameters.projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Link Evidence To Control
     * @param {EvidenceApiLinkEvidenceToControlRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public linkEvidenceToControl(requestParameters: EvidenceApiLinkEvidenceToControlRequest, options?: RawAxiosRequestConfig) {
        return EvidenceApiFp(this.configuration).linkEvidenceToControl(requestParameters.controlId, requestParameters.evidenceId, requestParameters.projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Query Evidences
     * @param {EvidenceApiQueryEvidencesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public queryEvidences(requestParameters: EvidenceApiQueryEvidencesRequest, options?: RawAxiosRequestConfig) {
        return EvidenceApiFp(this.configuration).queryEvidences(requestParameters.projectId, requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.descending, requestParameters.name, requestParameters.uniqueCode, requestParameters.fileType, requestParameters.associatedControlIds, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List evidences with the controls, lock state and users a list view renders.
     * @summary Query Evidences Expanded
     * @param {EvidenceApiQueryEvidencesExpandedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public queryEvidencesExpanded(requestParameters: EvidenceApiQueryEvidencesExpandedRequest, options?: RawAxiosRequestConfig) {
        return EvidenceApiFp(this.configuration).queryEvidencesExpanded(requestParameters.projectId, requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.descending, requestParameters.name, requestParameters.uniqueCode, requestParameters.fileType, requestParameters.associatedControlIds, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Unlink Evidence From Component
     * @param {EvidenceApiUnlinkEvidenceFromComponentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public unlinkEvidenceFromComponent(requestParameters: EvidenceApiUnlinkEvidenceFromComponentRequest, options?: RawAxiosRequestConfig) {
        return EvidenceApiFp(this.configuration).unlinkEvidenceFromComponent(requestParameters.componentId, requestParameters.evidenceId, requestParameters.projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Unlink Evidence From Control
     * @param {EvidenceApiUnlinkEvidenceFromControlRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public unlinkEvidenceFromControl(requestParameters: EvidenceApiUnlinkEvidenceFromControlRequest, options?: RawAxiosRequestConfig) {
        return EvidenceApiFp(this.configuration).unlinkEvidenceFromControl(requestParameters.controlId, requestParameters.evidenceId, requestParameters.projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Evidence
     * @param {EvidenceApiUpdateEvidenceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateEvidence(requestParameters: EvidenceApiUpdateEvidenceRequest, options?: RawAxiosRequestConfig) {
        return EvidenceApiFp(this.configuration).updateEvidence(requestParameters.evidenceId, requestParameters.updateEvidenceRequest, requestParameters.projectId, options).then((request) => request(this.axios, this.basePath));
    }
}

